import type { Screen } from '@noorview/core';

/** Screen status, shared by the web dashboard and the iPhone app. */

export const ONLINE_WINDOW_MS = 45_000;

export type ScreenStatus = 'online' | 'offline' | 'idle' | 'off' | 'unpaired';
export function screenStatus(s: Screen, now: number): ScreenStatus {
  if (!s.deviceId) return 'unpaired';
  const seen = s.lastSeenAt ? Date.parse(s.lastSeenAt) : 0;
  if (now - seen > ONLINE_WINDOW_MS) return 'offline';
  if (s.power === 'off') return 'off';
  if (s.power === 'idle') return 'idle';
  return 'online';
}
export const STATUS_LABEL: Record<ScreenStatus, string> = { online: 'Online', offline: 'Offline', idle: 'Idle', off: 'Off', unpaired: 'Not paired' };
export const STATUS_PILL: Record<ScreenStatus, string> = { online: 'online', offline: 'offline', idle: 'idle', off: 'off', unpaired: 'waiting' };

export function seenAgo(s: Screen, now: number): string {
  if (!s.deviceId) return 'Waiting for a display';
  if (!s.lastSeenAt) return 'Not seen yet';
  const d = Math.max(0, now - Date.parse(s.lastSeenAt));
  if (d < ONLINE_WINDOW_MS) return 'Seen now';
  const m = Math.round(d / 60_000);
  if (m < 60) return `Seen ${Math.max(1, m)}m ago`;
  const h = Math.round(m / 60);
  if (h < 48) return `Seen ${h}h ago`;
  return `Seen ${Math.round(h / 24)}d ago`;
}
